// extracted by mini-css-extract-plugin
export default {"stars":"StarRating_stars__8yv6r","star":"StarRating_star__HWrbX","filled":"StarRating_filled__LrHan"};